var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isMazeedNotActivated)?_c('span',{class:_vm.styles['fast-activation-badge']},[_c('span',[_vm._v("⚡")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_setup.I18nMessages['mazeed.fast_activation'])))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }